import type { ReactNode } from 'react';
import type { DraftKey } from 'types/drafts';
import { DraftChip } from './DraftChip';
import { DraftRowMenu } from './DraftRecordActions';

/**
 * A list's name cell, for a list with no actions column and no status chip: on a draft row the Draft chip goes under
 * the name, as the list frames draw it, and the draft's row menu beside it. Any other row keeps its cell as it is.
 */
export function DraftNameCell({ draft, children }: { draft: DraftKey | null; children: ReactNode }) {
    return draft ? (
        <div className="flex w-full items-start justify-between gap-1">
            <div className="flex min-w-0 flex-col items-start gap-1">
                {children}
                <DraftChip />
            </div>
            <DraftRowMenu draft={draft} className="size-7" />
        </div>
    ) : (
        children
    );
}
